var _title, _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGauge5(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 164,
    viewBox: "0 0 270 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Engagement Score Gauge at level 5 out of 5")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8456 6.66643C88.0065 7.26156 86.998 9.2349 87.5932 11.074C88.1883 12.9131 90.1616 13.9215 92.0007 13.3264C117.919 4.9392 145.835 5.02356 171.702 13.5672C173.538 14.1735 175.517 13.177 176.123 11.3415C176.73 9.50604 175.733 7.52664 173.898 6.9204C146.618 -2.08963 117.179 -2.17859 89.8456 6.66643ZM179.766 12.5013C180.545 10.7319 182.61 9.92827 184.379 10.7064C210.677 22.2717 232.609 41.9111 246.995 66.7779C247.963 68.451 247.392 70.5921 245.719 71.5601C244.046 72.5281 241.904 71.9565 240.936 70.2833C227.294 46.7036 206.498 28.0808 181.561 17.1142C179.792 16.336 178.988 14.2707 179.766 12.5013ZM247.41 74.5418C249.161 73.7217 251.244 74.476 252.064 76.2264C264.252 102.242 267.838 131.462 262.303 159.653C261.931 161.55 260.091 162.785 258.195 162.413C256.298 162.041 255.062 160.201 255.434 158.304C260.683 131.573 257.282 103.865 245.726 79.196C244.906 77.4455 245.66 75.3618 247.41 74.5418ZM17.5718 70.828C15.9097 69.841 15.3625 67.6935 16.3496 66.0315C31.0187 41.3303 53.1728 21.9422 79.6008 10.6774C81.379 9.91943 83.435 10.7465 84.1929 12.5247C84.9509 14.3029 84.1238 16.3589 82.3456 17.1168C57.2855 27.7986 36.2781 46.1831 22.3682 69.6058C21.3812 71.2678 19.2338 71.815 17.5718 70.828ZM4.51394 159.615C4.96076 161.496 6.84754 162.658 8.72819 162.211C10.6088 161.764 11.7712 159.878 11.3244 157.997C5.02739 131.493 7.33413 103.673 17.9102 78.5677C18.6607 76.7863 17.8249 74.7338 16.0436 73.9834C14.2622 73.2329 12.2097 74.0686 11.4593 75.85C0.305896 102.325 -2.12675 131.664 4.51394 159.615Z",
    fill: "url(#paint0_radial_590_35683)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_590_35683)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 260.585,
    cy: 114.585,
    r: 10.5391,
    transform: "rotate(0.25 260.585 114.585)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.585,
    cy: 114.585,
    r: 10.5391,
    transform: "rotate(0.25 260.585 114.585)",
    stroke: "#FCA572",
    strokeWidth: 7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_590_35683",
    x: 224.589,
    y: 91.7638,
    width: 71.9911,
    height: 71.9911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.3913
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.3913
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_590_35683"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.1739
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.9783
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_590_35683",
    result: "effect2_dropShadow_590_35683"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_590_35683",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_590_35683",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.50001 163.254) scale(250.5 312.633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#672BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA572"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge5);
export default __webpack_public_path__ + "assets/media/gauge-5.7cc90e53.svg";
export { ForwardRef as ReactComponent };